import React , { useState , useEffect } from 'react';
import { Link } from "react-router-dom";

const Pagination = ({ onPageChange ,total_pages, current_page }) => {
const [page_value, setpage_value] = useState(0)
const [selected_page, setselected_page] = useState(current_page)
const onClickNext = () => {
    if(page_value+2 < total_pages){
     
    setpage_value(page_value+1)
    }
}


const onClickPrevious = () => {
   if(page_value !== 0){
    setpage_value(page_value-1)
   }
}


const page_Change=(page)=>{
    setselected_page(page)
     setpage_value(page_value < page ? page_value+1 : page_value)
    onPageChange(page)
}

useEffect(() => {
  
    setselected_page(current_page)
    if(current_page === 1){

        setpage_value(0)
    }
}, [current_page])




  return (
    <>
      <div className="d-flex justify-content-end">
            <div className="pagination-wrap hstack gap-2">
                <Link onClick={onClickPrevious} className="page-item pagination-prev disabled" to="#">
                    Previous
                </Link>
                <ul className="pagination listjs-pagination mb-0">
                    <li onClick={()=>{
                        page_Change(page_value + 1)
                    }} className="page-item">
                        <a className={`page-link ${selected_page===(page_value+1)?'active':''}`} href="#">{  page_value + 1}</a>
                    </li>
                    <li onClick={()=>{
                        page_Change(page_value + 2)
                    }} className="page-item">
                       { (page_value+2 <= total_pages) && <a className={`page-link ${selected_page===(page_value+2)?'active':''}`}href="#">{ page_value+2}</a>}
                    </li>
                </ul>
                <Link onClick={onClickNext} className="page-item pagination-next" to="#">
                    Next
                </Link>
            </div>
        </div>
    </>
  )
}

export default Pagination
